import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "trustpilot-score-text" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = {
  key: 0,
  class: "break"
}
const _hoisted_4 = ["alt", "src", "width", "height"]
const _hoisted_5 = { class: "trustpilot-score-number" }
const _hoisted_6 = {
  key: 2,
  class: "break"
}
const _hoisted_7 = {
  key: 3,
  class: "trustpilot-review-count"
}

import { computed, type PropType } from "vue";
import labels from "../../shared/labels";
import { type TrustpilotData } from "../top-site/trustpilot-data";
import trustpilotBanner from "./trustpilot-logo.svg";
import invertedTrustpilotBanner from "./trustpilot-logo-inverted.svg";
import * as stars from "./stars-asset";


const __default__ = {
    compatConfig: {
        MODE: 3,
    },
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'trustpilot-banner',
  props: {
    modelValue: {
        type: Object as PropType<TrustpilotData>,
        required: true,
    },
    mobile: Boolean,
    invertedColors: Boolean,
},
  setup(__props) {

const props = __props;

const format = Intl.NumberFormat("da-DK");

function formattedNumber(n: number) {
    return format.format(n);
}

const link = computed(() => {
    if (props.modelValue.link == null) return undefined;
    if (props.modelValue.link == "") return undefined;
    return props.modelValue.link;
});

function roundStars(n: number) {
    return Math.round(n / 0.5) * 0.5;
}

const imageUrl = computed(() => {
    if (props.modelValue.scoreNumber == null) {
        return undefined;
    }
    switch (roundStars(props.modelValue.scoreNumber)) {
        case 1:
            return stars.stars_1;
        case 1.5:
            return stars.stars_1_5;
        case 2:
            return stars.stars_2;
        case 2.5:
            return stars.stars_2_5;
        case 3:
            return stars.stars_3;
        case 3.5:
            return stars.stars_3_5;
        case 4:
            return stars.stars_4;
        case 4.5:
            return stars.stars_4_5;
        case 5:
            return stars.stars_5;
    }
    return undefined;
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(link.value != null ? 'a' : 'div'), {
    href: link.value,
    target: link.value != null ? '_blank' : undefined,
    class: _normalizeClass({
            'trustpilot-banner': true,
            'trustpilot-banner--inverted': __props.invertedColors,
            'trustpilot-banner--desktop': !__props.mobile,
        })
  }, {
    default: _withCtx(() => [
      _createElementVNode("strong", _hoisted_1, _toDisplayString(__props.modelValue.scoreText), 1 /* TEXT */),
      _createElementVNode("img", {
        class: "trustpilot-logo",
        alt: __props.modelValue.logoAltText ?? 'trustpilot',
        src: __props.invertedColors ? _unref(invertedTrustpilotBanner) : _unref(trustpilotBanner),
        width: "74.11",
        height: "18"
      }, null, 8 /* PROPS */, _hoisted_2),
      (__props.mobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("v-if", true),
      (imageUrl.value != null)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            alt: __props.modelValue.scoreAltText ?? __props.modelValue.scoreText,
            src: imageUrl.value,
            class: "trustpilot-stars",
            width: __props.mobile ? 150 : 96,
            height: __props.mobile ? 28.13 : 18
          }, null, 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_5, _toDisplayString(formattedNumber(__props.modelValue.scoreNumber ?? 0)), 1 /* TEXT */),
      (__props.mobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : _createCommentVNode("v-if", true),
      (
                __props.mobile && __props.modelValue.reviews != null && __props.modelValue.reviews > 0
            )
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+" + _toDisplayString(__props.modelValue.reviews) + " " + _toDisplayString(_unref(labels).topSite.trustpilotReviews), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], undefined, true),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["href", "target", "class"])), [
    [_vShow, __props.modelValue.scoreNumber != null]
  ])
}
}

})